<template xmlns:v-on="http://www.w3.org/1999/xhtml">
	<div>
		<b-tooltip :disabled="helpState === false"
			target="choose-video-button">
			{{ $t('Tooltip.import_message') }}
		</b-tooltip>
		<b-tooltip :disabled="helpState === false"
			target="cut-video-button">
			{{ $t('Tooltip.cut_message') }}
		</b-tooltip>

		<b-modal ref="loaderModal"
			hide-footer
			static="true"
			:lazy=true
			:title="$t('Button.loader')">
			<throbber />
			<p class="my-4">{{ $t('Tooltip.message_wait') }}</p>
		</b-modal>

		<b-modal :size="'lg'"
			ref="previewModal"
			static="true"
			:lazy=true
			ok-only>
			<div class="embed-responsive embed-responsive-16by9">
				<video class="embed-responsive-item"
					:src="preview_path"
					ref="playerpreview"
					controls
					height="600"
					width="800"></video>
			</div>
		</b-modal>

		<b-modal
			:size="'lg'"
			ref="clipModal"
			static="true"
			:lazy="true"
			ok-only
		>
			<div class="embed-responsive embed-responsive-16by9">
				<video
					class="embed-responsive-item"
					:src="clip_path"
					ref="playerclip"
					controls
					height="600"
					width="800"
				></video>
			</div>
		</b-modal>

		<b-modal ref="modalError"
			hide-footer
			title="Erreur">
			<lottie_error />
			<p class="my-4">{{ text_error }}</p>
		</b-modal>

		<ul id="video-list" v-if="!showCarouselVideos">
			<li v-for="(item, index) in this.videos" :key="index"
				:style="{'background-image': 'url(' + base_url + '/public/storage/images/' + item[1] + ')'}"

			>
				<button class="play-overlay" @click="play_clip(item[0])">
					<div>▶&#xFE0E;</div>
				</button>
				<button :disabled="modified" v-if="index !== 0" class="left" @click="move(index, -1)">⭠&#xFE0E;</button>
				<button :disabled="modified" v-if="index !== videos.length - 1" class="right" @click="move(index, 1)">⭢&#xFE0E;</button>
				<button :disabled="modified" class="delete" @click="del_video(item[0], index)">❌&#xFE0E;</button>
			</li>
		</ul>

		<div class="row">
			<div class="col-12" v-if="showCarouselVideos">
				<!--				<div v-if="!showCarouselVideos"-->
				<!--					class="embed-responsive embed-responsive-16by9">-->
				<!--					<video class="embed-responsive-item"-->
				<!--						:src="videoUrl"-->
				<!--						ref="videoplayer"-->
				<!--						controls></video>-->
				<!--				</div>-->
				<flickity v-if="showCarouselVideos && carouselVideos.length > 0"
					:options="flickityOptions">
					<div class="carousel-cell"
						v-for="(ambiance, index) in this.carouselVideos"
						:key="index">
						<video class=""
							controls>
							<source :src="ambiance.url" />
						</video>
						<div class="ambiance-checkbox">
							<label><input class="checkbox_ambiances"
								type="checkbox"
								v-model="ambiance.checked"
								:id="index"
								:value="ambiance"
								@click="setVideo(ambiance)"
								ref="checkboxAmbiances"> {{ ambiance.name.replace(/_/g, " ") }}</label>
						</div>
					</div>
				</flickity>

			</div>

			<div class="col-12">
				<div class="row"> <!-- first button row -->
					<b-col md="auto" v-if="!hasCarouselVideos">
						<label
							class="btn btn-edition"
							id="choose-video-button"
							v-if="!modified"
						>{{ $t("Button.import") }} <input
							type="file"
							id="input_newfile"
							ref="fileUpload"
							accept="video/mp4, video/quicktime"
							@change="upload_file"
							hidden
							:disabled="modified"
						></label>
						<span v-if="modified" class="modificationLabel button-aligned">Texte et options sonores à valider avant de pouvoir éditer les vidéos</span>
					</b-col>

					<b-col v-if="hasCarouselVideos"
						md="auto"
						v-bind:style="[showCarouselVideos === true ? {defaultVideosNotShow} : {defaultVideosShow}]">
						<div class="btn btn-cut btn-edition"
							@click="selectDefaultVideo">{{ defaultVideosButtonText }}
						</div>
					</b-col>

				</div> <!-- first button row -->

				<div class="row"> <!-- second button row -->
					<b-col v-if="!hasCarouselVideos && ready_for_edit && videos.length > 0"
						md="auto"
						v-bind:style="[showCarouselVideos === true ? {defaultVideosShow} : {defaultVideosNotShow}]">
						<button class="btn btn-cut btn-edition"
							@click="goToCut"
							:disabled="modified"
							id="cut-video-button">{{ $t('Button.cut') }}
						</button>
					</b-col>
					<b-col v-if="!hasCarouselVideos && ready_for_edit && false"
						md="auto"
						v-bind:style="[showCarouselVideos === true ? {defaultVideosShow} : {defaultVideosNotShow}]">
						<button class="btn btn-cut btn-edition"
							@click="goToCut"
							:disabled="modified"
							id="cut-video-button-2">{{ $t('Button.import_sequence') }}
						</button>
					</b-col>
					<b-col v-if="hasVoiceOver">
						<router-link
							:to="{ name: 'VoiceOverEdition', params: { projectId: projectId, step_type: 'StepAmbiance', stepId: id}}"
							class="btn btn-insert-voice"
							id="insert-voice-over-button">{{ $t('Ambiance.insertVoiceOverButtonText') }}
						</router-link>
					</b-col>
				</div> <!-- second button row -->

				<div class="row mt-3"> <!-- inputs -->
					<div class="col-12" ref="stepOfficeFields">
						<form>
							<div class="row">
								<div class="col-8">
									<div class="form-group"
										v-if="hasTitleField">
										<label class="sentence_label"
											for="title">{{ $t("Ambiance.title") }}</label>
										<span class="modificationLabel"> {{ this.modificationTitle }} </span>
										<input type="text"
											class="form-control no-border"
											:class="[ inputValueTitle.length >= 100 ? 'warning' : '' ]"
											id="title"
											@change="setModificationTitleLabel"
											@input="setModificationTitleLabel"
											v-model="inputValueTitle"
											ref="inputTitle">
									</div>
									<div class="form-group"
										v-if="hasSecondaryTitleField">
										<label class="subtitle_label"
											for="subtitle2">{{ $t("Ambiance.secondary_title") }}</label>
										<span class="modificationLabel"> {{ this.modificationSecondaryTitle }} </span>
										<input type="text"
											class="form-control no-border"
											:class="[ inputValueSubtitle.length >= 100 ? 'warning' : '' ]"
											@change="setModificationSecondaryTitleLabel"
											@input="setModificationSecondaryTitleLabel"
											id="subtitle2"
											v-model="inputValueSubtitle" ref="inputSubtitle">
									</div>
									<div class="form-group"
										v-if="hasKeywordsField">
										<label class="subtitle_label"
											for="subtitle">{{ $t("Ambiance.keywords") }}</label>
										<span class="modificationLabel"> {{ this.modificationKeywords }} </span>
										<input type="text"
											class="form-control no-border"
											id="subtitle"
											@change="setModificationKeywordsLabel"
											@input="setModificationKeywordsLabel"
											v-model="inputValueKeywords"
											ref="inputSubtitle">
									</div>
									<div class="form-group" v-if="!hasCarouselVideos">
										<label><input type="checkbox" name="mute" v-model="isMuted"
											@change="setModified" /> {{ $t("Button.mute") }}</label>
										<span class="modificationLabel"> {{ this.modification_mute }} </span><br />
										<label>Volume : {{ volume }}%<br /><input :disabled="isMuted" @change="setModified" type="range" id="volume" name="volume"
											min="10" max="200" step="10" v-model="volume"></label>
									</div>
								</div> <!--  -->
								<div class="col-4"> <!-- audio inputs -->
									<div class="form-group">
										<label><input type="checkbox" name="mute" v-model="hasMusicEnable"
											@change="setModified" /> {{ $t("Button.enable_music") }}</label>
										<span class="modificationLabel"></span><br />
										<label>Volume : {{ music_volume }}%<br /><input :disabled="!hasMusicEnable" @change="setModified" type="range" id="music_volume" name="music_volume"
											min="10" max="100" step="10" v-model="music_volume"></label>
									</div>
								</div>
							</div>
						</form>
					</div>
				</div> <!-- inputs -->
			</div>
		</div>

		<div class="row"> <!--Bottom buttons -->
			<div class="col-12 col-lg-12">
				<b-row>
					<b-col md="auto">
						<ValidStep
							class="mt-4"
							:hasUploadedFile="hasUploadedFile"
							:valueTitle="inputValueTitle"
							:modal="$refs.loaderModal"
							:id="id"
							:muted="isMuted"
							:music_enabled="hasMusicEnable"
							:volume="volume"
							:music_volume="music_volume"
							:completed="isCompleted"
							:valueSubtitle="inputValueSubtitle"
							:valueKeywords="inputValueKeywords"
							:uploadVideoFile="uploadedFiles"
							:videoArray="this.carouselVideos.filter(step => step.checked === true)"
							:stepOrder="stepIndex"
							:activate_upload="activate_upload"
							:disabled="!(modified && (has_video || activate_upload))"
						/>
					</b-col>
					<b-col md="auto" style="padding-left: 0;">
						<div class="mt-4">
							<button
								class="btn btn-preview"
								:disabled="!isCompleted || modified"
								@click="preview"
							>{{ $t("Button.preview") }}
							</button>
						</div>
					</b-col>

					<!--					<b-col md="auto" style="padding-left: 0;">-->
					<!--						<div class="mt-4">-->
					<!--							<a href="#"-->
					<!--								@click.prevent="cancelUploadVideo"-->
					<!--								:class="[isSaved ? 'btn btn-cancel' : 'disabled btn btn-cancel']">{{ $t("Button.cancel") }}</a>-->
					<!--						</div>-->
					<!--					</b-col>-->
					<b-col md="auto" style="padding-left: 0;">
						<div class="mt-4">
							<a href="#"
								class="btn btn-reinitialization"
								@click="reset"
								:class="[isCompleted ? '' : 'disabled']">{{ $t("Button.reset") }}</a>
						</div>
					</b-col>
					<b-col md="auto" style="padding-left: 0;">
						<div class="mt-4">
							<a href="#"
								class="btn btn-cancel"
								@click="reset_modified"
								:class="[modified ? '' : 'disabled']">{{ $t("Button.modifications") }}</a>
						</div>
					</b-col>
					<b-col md="auto" style="padding-left: 0; margin-left: auto;">
						<div class="mt-4">
							<button v-if="!hasSubtitles && voiceOverBoolean && voiceOverId !== null"
								type="submit"
								class="btn btn-info"
								@click.prevent="goToEdition">{{ $t('Button.add_subtitles') }}
							</button>
							<button v-if="hasSubtitles && voiceOverBoolean && voiceOverId !== null"
								type="submit"
								class="btn btn-info"
								@click.prevent="goToEdition">{{ $t('Button.edit_subtitles') }}
							</button>
						</div>
					</b-col>
				</b-row>
			</div>
		</div>
	</div>
</template>

<script>
import ValidStep from "../ui/buttons/ValidStepOffice";
import Flickity from "vue-flickity";
import {EventBus} from "../../event/event-bus";
import axios from "axios";
import throbber from "@/components/ui/throbber";
import lottie_error from "@/components/ui/lottie_error";

const BASE_URL = process.env.VUE_APP_BASE_URL;

export default {
	name: "StepOffice",
	components: {
		ValidStep,
		Flickity,
		throbber,
		lottie_error,
	},
	props: {
		helpState: {
			type: Boolean,
			required: true,
		},
		id: Number,
		stepName: String,
		title: String,
		secondaryTitle: String,
		keywords: String,
		isVisible: Boolean,
		isCompleted: Boolean,
		hasTitleField: Boolean,
		hasSecondaryTitleField: Boolean,
		hasKeywordsField: Boolean,
		hasCarouselVideos: Boolean,
		hasUploadedFile: Boolean,
		hasVoiceOver: Boolean,
		video: Object,
		groupId: String,
		projectId: Number,
		ambiance: Object,
		voiceOverId: Number,
		renderId: String,
		stepIndex: Number,
		created_at: String,
		updated_at: String,
	},
	data() {
		return {
			base_url: process.env.VUE_APP_BASE_URL,
			results: [],
			text_error: "",
			valueTitle: "",
			valueSubtitle: "",
			valueKeywords: "",
			uploadedFiles: [],
			carouselVideos: [],
			hasSubtitles: false,
			isMuted: false,
			hasMusicEnable: true,
			volume: 100,
			music_volume: 100,
			isSaved: false,
			hasVideo: false,
			showCarouselVideos: false,
			flickityOptions: {
				initialIndex: 0,
				prevNextButtons: true,
				pageDots: false,
				wrapAround: false,
				draggable: false,
			},
			defaultVideosNotShow: {
				"padding": "0px",
				"cursor": "pointer",
			},
			defaultVideosShow: {
				"cursor": "pointer",
			},
			defaultVideosButtonText: "Choisir ma vidéo de fond",
			voiceOver: false,
			videos: [],
			videoUrl: "",
			modified: false,
			ambianceId: "",
			modificationTitle: "",
			modificationKeywords: "",
			modificationSecondaryTitle: "",
			modification_mute: "",
			preview_path: "",
			clip_path: "",
			activate_upload: false,
			ready_for_edit: false,
			has_video: false,
		};
	},
	computed: {
		inputValueTitle: {
			get() {
				return this.valueTitle;
			},
			set(v) {
				this.valueTitle = v;
			},
		},
		inputValueSubtitle: {
			get() {
				return this.valueSubtitle;
			},
			set(v) {
				this.valueSubtitle = v;
			},
		},
		inputValueKeywords: {
			get() {
				return this.valueKeywords;
			},
			set(v) {
				this.valueKeywords = v;
			},
		},
		voiceOverBoolean: {
			get() {
				return this.hasVoiceOver;
			},
			set(v) {
				this.hasVoiceOver = v;
			},
		},
	},
	updated() {
		EventBus.$on("hasUploadedFile", value => {
			this.hasUploadedFile = value;
		});
	},
	created() {
		let $this = this;
		EventBus.$on("setModificationTitleLabel", label => {
			$this.modificationTitle = label;
		});
		EventBus.$on("setModificationKeywordsLabel", label => {
			$this.modificationKeywords = label;
		});
		EventBus.$on("setModificationSecondaryTitleLabel", label => {
			$this.modificationSecondaryTitle = label;
		});
		EventBus.$on("setModified", bool => {
			if (bool) {
			}
			else {
				this.reset_modified();
			}
		});
		EventBus.$on("setStepAmbianceComplete", id => {
			// $this.getDatas();
		});
		EventBus.$on("stepAmbianceReload", id => {
			$this.getDatas();
		});
		EventBus.$on("isSaved", function (value) {
			if (value) {
				$this.isSaved = !value;
			}
			$this.showCarouselVideos = false;
			$this.getDatas();
		});
		EventBus.$on("videoCarouselChoose", function (value) {
			if (value) {
				$this.showCarouselVideos = !value;
				$this.getDatas();
			}
		});
		EventBus.$on("hasVideo", function (value) {
			if (value) {
				$this.hasVideo = value;
			}
		});
		EventBus.$on("hasVoiceOver", function (value) {
			if (value) {
				$this.voiceOverBoolean = value;
			}
		});
		EventBus.$on("reload_carousels", id => {
			$this.getDatas();
			// Unorthodox, but we need to refresh the step carousel and it'll call getDatas anyway
			// EventBus.$emit('setStepAmbianceComplete', $this.id);
		});
	},
	beforeRouteEnter(to, from, next) {
		axios.get(BASE_URL + "/public/api/stepAmbiances/" + to.params.stepId, {
			headers: {
				"Authorization": sessionStorage.getItem("auth"),
			},
		}).then(response => {
			next(vm => {
				let data = response.data.data;
				if (data.video !== undefined) {
					vm.videoUrl = data.video.url;
				}
				if (data.ambianceId !== undefined) {
					vm.videoUrl = data.ambiance.url;
				}
			});
		});
	},
	activated() {
		this.getDatas();
	},
	methods: {
		preview() {
			this.$refs.loaderModal.show();

			axios.get(BASE_URL + "/public/api/stepAmbiances/" + this.id + "/preview",
				{
					headers: {
						"Authorization": sessionStorage.getItem("auth"),
					},
				})
			.then(response => {
				let data = response.data;

				this.$refs.loaderModal.hide();

				this.preview_path = BASE_URL + "/public/storage/videos/generated/" + data.url + "#" + new Date().getTime();
				this.$refs.previewModal.show();
			}).catch(error => {
				this.$refs.loaderModal.hide();
				this.text_error = this.$root.$t("Errors.message_project") + error;
				this.$refs.modalError.show();
			});
		},
		move(index, change) {
			let new_order = new Array(this.videos.length).fill(undefined).map((_, i) => i);
			new_order[index] = index + change;
			new_order[index + change] = index;

			let bodyFormData = new FormData();
			bodyFormData.append("order", JSON.stringify(new_order));

			let new_values = [];
			for (let key of new_order) {
				new_values.push(this.videos[key]);
			}
			this.videos = new_values;

			let $this = this;
			axios.post(BASE_URL + "/public/api/stepAmbiances/" + this.id + "/reorder",
				bodyFormData,
				{
					headers: {
						"Content-Type": "multipart/form-data",
						"Authorization": sessionStorage.getItem("auth"),
					},
				},
			).then(function () {
				// $this.loadData();
			})
			.catch(error => {
				$this.text_error = this.$root.$t("Errors.message_project") + error;
				$this.$refs.modalError.show();
			});

			// reload
		},
		del_video(name, index) {
			console.log(name);
			let bodyFormData = new FormData();
			bodyFormData.append("value", name);
			this.$refs.loaderModal.show();
			let $this = this;
			axios.post(BASE_URL + "/public/api/stepAmbiances/" + this.id + "/deletevideo",
				bodyFormData,
				{
					headers: {
						"Content-Type": "multipart/form-data",
						"Authorization": sessionStorage.getItem("auth"),
					},
				},
			).then(function () {
				$this.getDatas();
				$this.$refs.loaderModal.hide();
			})
			.catch(error => {
				$this.text_error = this.$root.$t("Errors.message_project") + error;
				$this.$refs.modalError.show();
			});
		},
		play_clip(filename) {
			console.log(filename);
			this.clip_path = BASE_URL + "/public/storage/videos/" + filename;
			this.$refs.clipModal.show();
		},
		reset() {
			this.$refs.loaderModal.show();
			let $this = this;

			axios.get(BASE_URL + "/public/api/stepAmbiances/" + this.id + "/reset",
				{
					headers: {
						"Authorization": sessionStorage.getItem("auth"),
					},
				})
			.then(response => {
				this.$refs.loaderModal.hide();
				this.getDatas();
			}).catch(error => {
				this.$refs.loaderModal.hide();
				$this.text_error = this.$root.$t("Errors.message_project") + error;
				$this.$refs.modalError.show();
			});
		},
		getDatas() {
			let _id = this.id;
			let $this = this;
			$this.carouselVideos = [];
			axios.get(BASE_URL + "/public/api/stepAmbiances/" + _id, {
				headers: {
					"Authorization": sessionStorage.getItem("auth"),
				},
			})
			.then(response => {
				let data = response.data.data;

				this.isCompleted = data.isCompleted;
				this.isMuted = data.isMuted;
				this.hasMusicEnable = data.hasMusicEnable;
				this.volume = data.volume;
				this.music_volume = data.music_volume;

				if (data.title !== null) {
					$this.inputValueTitle = data.title;
				}
				else {
					$this.inputValueTitle = "";
				}

				if (data.secondaryTitle !== null) {
					$this.inputValueSubtitle = data.secondaryTitle;
				}
				else {
					$this.inputValueSubtitle = "";
				}

				if (data.keywords !== null) {
					$this.inputValueKeywords = data.keywords;
				}
				else {
					$this.inputValueKeywords = "";
				}

				if (data.video !== undefined) {
					$this.videoUrl = data.video.url;
					$this.hasVideo = true;
					$this.has_video = true; // Not the same, not a step property but a flag
					$this.ready_for_edit = true;
				}
				else if (data.ambiance !== undefined) {
					$this.videoUrl = data.ambiance.url;
					$this.ambianceId = data.ambiance.id;
					$this.ready_for_edit = true;
					$this.has_video = true;
				}
				else {
					$this.videoUrl = "";
				}

				if (data.subtitles && data.subtitles.length > 0) {
					$this.hasSubtitles = true;
				}

				$this.videos = JSON.parse(data.video_list);
				if ($this.videos.length > 0) {
					this.has_video = true;
					this.ready_for_edit = true;
				}

				if ($this.hasCarouselVideos) {
					axios.get(BASE_URL + "/public/api/ambiances/" + _id, {
						headers: {
							"Authorization": sessionStorage.getItem("auth"),
						},
					})
					.then(function (response) {
						let ambiances = response.data.data.ambiances;
						ambiances.forEach(function (element) {
							if (element.id === Number($this.ambianceId)) {
								element.checked = "checked";
							}
							$this.carouselVideos.push(element);
						});
					});
				}

				if (data.isCompleted) {
					EventBus.$emit("setStepAmbianceComplete", $this.id);
				}
				else {
					EventBus.$emit("setStepAmbianceNotComplete", $this.id);
				}
			}).catch(error => {
				this.$refs.loaderModal.hide();
				this.text_error = this.$root.$t("Errors.message_project") + error;
				this.$refs.modalError.show();
			});
		},
		setVideo(video) {
			this.carouselVideos.forEach(function (element) {
				if (video.id !== element.id) {
					element.checked = false;
				}
			});
			this.modified = true;
			this.has_video = true;
			this.defaultVideosButtonText = "Choisir ma vidéo de fond";
		},
		cutVideo() {
			this.$router.push({
				name: "VideoEdition",
				params: {projectId: this.projectId, step_type: "App\\StepAmbiance", stepId: this.id},
			});
		},
		handleFileUpload() {
			EventBus.$emit("lock_steps", {id: this.id, type: "App\\StepAmbiance"});
			this.activate_upload = true;
			this.modified = true;
			this.ready_for_edit = false;
			let $this = this;
			if ($this.uploadedFiles.length > 1) {
				$this.uploadedFiles.splice(0, 1);
			}
			let inputFiles = $this.$refs.fileUpload.files;
			this.isSaved = true;
			let player = $this.$refs.videoplayer;
			if (inputFiles.length >= 1) {
				for (let i = 0; i <= inputFiles.length - 1; i++) {
					$this.videoUrl = URL.createObjectURL(inputFiles[i]);
					player.onloadeddata = function () {
						$this.uploadedFiles = [];
						$this.uploadedFiles.push({
							id: i,
							filename: inputFiles[i].name,
							file: inputFiles[i],
							video_duration: player.duration,
						});

						URL.revokeObjectURL(inputFiles[i]);
					};
				}
			}
		},
		cancelUploadVideo() {
			let inputFiles = this.$refs.fileUpload.files;
			if (inputFiles[0]) {
				if (inputFiles[0].name !== this.videoName) {
					let player = this.$refs.videoplayer;
					player.src = this.videoPath;
				}
			}
			this.$refs.fileUpload.value = "";
			this.isSaved = false;
		},
		upload_file() {
			let files = document.getElementById("input_newfile").files;

			if (!files.length) {
				return 0;
			}

			let bodyFormData = new FormData();
			bodyFormData.append("video", files[0]);

			this.$refs.loaderModal.show();
			let $this = this;
			axios.post(BASE_URL + "/public/api/stepAmbiances/" + this.id + "/addvideo",
				bodyFormData,
				{
					headers: {
						"Content-Type": "multipart/form-data",
						"Authorization": sessionStorage.getItem("auth"),
					},
				},
			).then(function () {
				$this.getDatas();
				$this.$refs.loaderModal.hide();
			})
			.catch(error => {
				$this.text_error = this.$root.$t("Errors.message_project") + error;
				$this.$refs.modalError.show();
				$this.$refs.loaderModal.hide();
			});
		},
		selectDefaultVideo() {
			if (this.hasCarouselVideos) {
				this.showCarouselVideos = !this.showCarouselVideos;
			}
			if (this.showCarouselVideos === true) {
				this.defaultVideosButtonText = "Annuler";
			}
			else {
				this.defaultVideosButtonText = "Choisir ma vidéo de fond";
			}
		},
		goToEdition() {
			this.$router.push({
				name: "SubtitleEdition",
				params: {projectId: this.projectId, step_type: "App\\StepAmbiance", stepId: this.id},
			});
		},
		goToCut() {
			if (this.videos.length > 0) {
				this.$router.push({
					name: "VideoEdition",
					params: {projectId: this.projectId, step_type: "App\\StepAmbiance", stepId: this.id},
				});
			}
		},
		setModificationTitleLabel() {
			this.modified = true;
			this.modificationTitle = this.$root.$t("Button.editing");
			EventBus.$emit("lock_steps", {id: this.id, type: "App\\StepAmbiance"});
		},
		setModificationKeywordsLabel() {
			this.modified = true;
			this.modificationKeywords = this.$root.$t("Button.editing");
			EventBus.$emit("lock_steps", {id: this.id, type: "App\\StepAmbiance"});
		},
		setModificationSecondaryTitleLabel() {
			this.modified = true;
			this.modificationSecondaryTitle = this.$root.$t("Button.editing");
			EventBus.$emit("lock_steps", {id: this.id, type: "App\\StepAmbiance"});
		},
		setModified() {
			this.modified = true;
			this.modification_mute = this.$root.$t("Button.editing");
			EventBus.$emit("lock_steps", {id: this.id, type: "App\\StepAmbiance"});
		},
		reset_modified() {
			this.getDatas();
			EventBus.$emit("unlock_steps", {id: this.id, type: "App\\StepAmbiance"});
			this.modified = false;
			this.modification_mute = "";
			this.modificationTitle = "";
			this.modificationSecondaryTitle = "";
			this.modificationKeywords = "";
			this.activate_upload = false;
		},
	},
};
</script>

<style scoped>

.sentence_label,
.keywords_label,
.subtitle_label {
	font-size: 14px;
	color: var(--text-main);
}

.btn {
	margin-left: auto;
	white-space: nowrap;
	border-radius: var(--small-border-radius);
}

input[type=file] {
	position: absolute;
	top: 0;
	right: 0;
	min-width: 100%;
	min-height: 100%;
	font-size: 100px;
	text-align: right;
	filter: alpha(opacity=0);
	opacity: 0;
	outline: none;
	background: white;
	cursor: inherit;
	display: block;
}

input {
	border-radius: 0;
	border-top: none;
	border-left: none;
	border-right: none;
	border-bottom: #8AA0B2 solid 1px;
}

.btn-reinitialization {
	background-color: var(--color-cancel);
	border-color: var(--color-cancel);
	color: var(--text-cancel);
}

.btn-edition {
	background-color: var(--color-secondary-action);
	border-color: var(--color-secondary-action);
	cursor: pointer;
	color: var(--text-secondary-action);
	margin-bottom: 6px;
}

.btn:hover {
	filter: brightness(80%);
}

.btn-cut,
.btn-insert-voice {
	cursor: pointer;
	background-color: var(--color-secondary-action);
	border-color: var(--color-secondary-action);
	color: var(--text-secondary-action);
	margin-left: 0;
}

.btn-info {
	background-color: var(--color-secondary-action);
	border-color: var(--color-secondary-action);
	color: var(--text-secondary-action);
}

.btn-preview {
	background-color: var(--color-main-action);
	border-color: var(--color-main-action);
	color: var(--text-secondary-action);
}

.ambiance-checkbox {
	text-align: center;
}

.modificationLabel {
	font-size: 14px;
	color: var(--color-modification);
}

.btn-cancel {
	background-color: var(--color-modification);
	border-color: var(--color-modification);
	color: var(--text-modification);
}

.carousel-cell {
	width: 100%;
	/*padding-bottom: calc(56.25% + 50px);*/
	height: 360px;
}

.carousel-cell video {
	display: block;
	margin: 10px auto;
	border-radius: var(--big-border-radius);
	width: 500px;
	height: 300px;
	background: #2C2A29;
	box-shadow: 0 0 10px #00000050;
}

.embed-responsive {
	border: none;
	border-radius: var(--big-border-radius);
	box-shadow: 0 0 15px #00000033;
}

input.warning {
	color: red;
}

#video-list {
	list-style: none;
	display: flex;
	flex-wrap: wrap;
	justify-content: flex-start;
	align-items: stretch;
	gap: 15px;
	min-height: 120px;
	padding: 0;
}

#video-list li {
	width: 160px;
	height: 90px;
	border-radius: var(--big-border-radius);
	border: 1px solid grey;
	box-sizing: border-box;
	position: relative;
	overflow: hidden;
	background-position: center;
	background-size: cover;
	user-select: none;
}

#video-list button {
	border: 0;
	position: absolute;
	visibility: hidden;
	background: #FFFFFF90;
}

#video-list .play-overlay {
	position: absolute;
	visibility: hidden;
	width: 160px;
	height: 90px;
	background: none;
	left: 0;
	top: 0;
	overflow: hidden;
	color: #FFFFFF80;
	cursor: default;
}

#video-list .play-overlay div {
	position: absolute;
	width: 60px;
	height: 70px;
	padding-left: 5px;
	left: 50%;
	top: 5px;
	transform: translateX(-50%);
	font-size: 70px;
	overflow: hidden;
	line-height: 70px;
	text-align: center;
	color: #FFFFFF80;
	cursor: pointer;
}

#video-list li:hover .play-overlay,
#video-list li:hover button {
	visibility: visible;
}

#video-list button.left {
	bottom: 0;
	left: 0;
	border-radius: 0 5px 0 0;
	padding: 5px 10px;
	line-height: 20px;
	font-size: 30px;
}

#video-list button.right {
	bottom: 0;
	right: 0;
	border-radius: 5px 0 0 0;
	padding: 5px 10px;
	line-height: 20px;
	font-size: 30px;
}

#video-list button.delete {
	top: 0;
	right: 0;
	border-radius: 0 0 0 5px;
	background: var(--color-main-action);
	color: white;
}

</style>
